/** Access-token lever fem minuter. Förnya medan användaren arbetar, logga ut efter inaktivitet. */
export const SESSION_REFRESH_INTERVAL_MS = 4 * 60 * 1000;
export const SESSION_ACTIVE_WINDOW_MS = 5 * 60 * 1000;
export const SESSION_INACTIVITY_LOGOUT_MS = 30 * 60 * 1000;

export function shouldRefreshSession(idleMs: number, sinceRefreshMs: number): boolean {
  return idleMs < SESSION_ACTIVE_WINDOW_MS && sinceRefreshMs >= SESSION_REFRESH_INTERVAL_MS;
}

export function shouldLogoutForInactivity(idleMs: number): boolean {
  return idleMs >= SESSION_INACTIVITY_LOGOUT_MS;
}
